import React, { useState, useEffect, useCallback } from "react";
import "../../../../../Assets/Styles/Select.scss";
import CloseIcon from "../../../../../Assets/Images/x-circle.svg";

const MultiSelect = (props) => {
  const [PreSelected, setPreSelected] = useState("");
  const [IsOpen, setIsOpen] = useState(true);
  const [SelectedItems, setSelectedItems] = useState([]);
  const [ListLength, setLisLength] = useState(0);

  useEffect(() => {
    if (props.Name) {
      setPreSelected(props.Name);
    } else {
      setPreSelected(props.Initial);
    }
  }, [props.Name]);

  const handleDropDown = () => {
    setIsOpen(!IsOpen);
    if (IsOpen) {
      document
        .getElementById(props.Id + "-select")
        .classList.add("select-dropdown-is-open");
      document.getElementById(props.Id + "-select").click();
    } else {
      document
        .getElementById(props.Id + "-select")
        .classList.remove("select-dropdown-is-open");
    }
  };
  const selectItem = (Option) => {
    var ClassList;
    if (props.IsWithId) {
      ClassList = document.getElementById("icon-" + Option.id).classList;
    } else {
      ClassList = document.getElementById("icon-" + Option).classList;
    }
    if (ClassList.length == 1) {
      if (props.IsWithId) {
        document
          .getElementById("icon-" + Option.id)
          .classList.add("feather-check-selected");
        addToSelectedItems(Option.id);
      } else {
        document
          .getElementById("icon-" + Option)
          .classList.add("feather-check-selected");
        addToSelectedItems(Option);
      }
    } else {
      if (props.IsWithId) {
        document
          .getElementById("icon-" + Option.id)
          .classList.remove("feather-check-selected");
        deleteFromSelectedItems(Option.id);
      } else {
        document
          .getElementById("icon-" + Option)
          .classList.remove("feather-check-selected");
        deleteFromSelectedItems(Option);
      }
    }
    if (props.ChangeHandler) {
      props.ChangeHandler();
    }
    if (props.SaveSelectedOptions) {
      let Selected = [];
      props.Options.map((Opt) => {
        if (
          document
            .getElementById("icon-" + Opt.id)
            .classList.contains("feather-check-selected")
        ) {
          Selected.push(Opt);
        }
      });
      props.SaveSelectedOptions(Selected);
    }
  };
  const addToSelectedItems = useCallback(
    (Option) => {
      let ListOfItems = SelectedItems;
      ListOfItems.push(Option);
      setSelectedItems(ListOfItems);
      setLisLength(ListOfItems.length);
      document.getElementById(props.Id + "-filter").value = ListOfItems;
    },
    [SelectedItems]
  );
  const deleteFromSelectedItems = useCallback(
    (Option) => {
      let ListOfItems = SelectedItems;
      ListOfItems = ListOfItems.filter((Item) => {
        return Item !== Option;
      });
      setSelectedItems(ListOfItems);
      setLisLength(ListOfItems.length);
      document.getElementById(props.Id + "-filter").value = ListOfItems;
    },
    [SelectedItems]
  );
  const clearItems = () => {
    SelectedItems.map((Item) => {
      document
        .getElementById("icon-" + Item)
        .classList.remove("feather-check-selected");
      deleteFromSelectedItems(Item);
    });
    setSelectedItems([]);
    setLisLength(0);
    if (props.ClearAction) {
      props.ClearAction();
    }
    props.ChangeHandler();
    if (props.OnReset) {
      props.OnReset();
    }
  };
  return (
    <React.Fragment>
      {!IsOpen ? (
        <div
          onClick={() => handleDropDown()}
          className="select-outline-area"
        ></div>
      ) : null}
      <div className="cx-multi-select" id={props.Id + "-select"}>
        {ListLength === 0 ? (
          <button
            onClick={() => handleDropDown()}
            className="select-trigger"
          ></button>
        ) : (
          <React.Fragment>
            <button onClick={() => handleDropDown()} className="select-trigger">
              <p
                className="label-text selected-count"
                id={"pre-selected-" + props.Id}
              >
                {SelectedItems.length + " Selected"}
              </p>
            </button>
            <img
              className="clear"
              id={props.Id + "-clear"}
              onClick={() => clearItems()}
              alt="X"
              src={CloseIcon}
            />
          </React.Fragment>
        )}
        <input className="hidden" id={props.Id + "-filter"} />
        {SelectedItems.length === 0 ? (
          <p className="label-text" id={"pre-selected-" + props.Id}>
            {PreSelected}
          </p>
        ) : (
          <p
            className="label-text label-text-transformed"
            id={"pre-selected-" + props.Id}
          >
            {null}
          </p>
        )}
        <i
          className="feather-chevron-down"
          onClick={() => handleDropDown()}
        ></i>
        <section className="cx-dropdown">
          {props.Options.map((option) => (
            <div
              id={"option-" + option.id}
              className="option-item"
              onClick={() => selectItem(option)}
              key={option.id}
            >
              <span>
                <i className="feather-check" id={"icon-" + option.id}></i>
              </span>
              <p>{option.name}</p>
            </div>
          ))}
        </section>
        <p className="select-validation-message">{props.ValidationError}</p>
      </div>
    </React.Fragment>
  );
};

export default MultiSelect;
